import {
  SET_MENU_CLICKED_CONTROL_MODAL_DATA,
  SET_CATALOG_MODAL_DELETE_ROW_ID,
  SET_WMS_AGREEMENT_MODAL_DATA,
} from './mutation-types';

export default {
  [SET_MENU_CLICKED_CONTROL_MODAL_DATA](state, payload) {
    state.menuClickControlModalData = payload;
  },
  [SET_CATALOG_MODAL_DELETE_ROW_ID](state, payload) {
    state.catalogModalDeleteRowId = payload;
  },
  [SET_WMS_AGREEMENT_MODAL_DATA](state, payload) {
    state.wmsAgreementModalData = payload;
  },
};
